import React from "react";
import { color } from "./constants";

const CheckBox = (props) => {
  return (
    <label
      style={{
        ...props.style,
        position: "relative",
        display: "flex",
        alignItems: "center",
      }}
    >
      <input
        type="checkbox"
        value={props.value}
        checked={props.checked}
        onChange={(event) => props.handleChange(event, props.index)}
        style={{ visibility: "hidden", marginRight: '8px' }}
        name={props.name}
      />

      <span
        style={{
          position: "absolute",
          left: 0,
          top: 7,
          width: "16px",
          height: "16px",
          border: `2px solid  ${props.checked ? color.chekColor : color.greydark}`,
          background: props.checked ? color.chekColor : "#fff",
        }}
      ></span>
      <span
        style={{
          position: "absolute",
          left: "5px",
          top: "9px",
          width: "5px",
          height: "11px",
          border: "1px solid #fff",
          borderWidth: "0 2px 2px 0",
          transform: "rotate(45deg)",
          zIndex: 2,
        }}
      ></span>
      {props.showValue}
    </label>
  );
};

export default CheckBox;
